export default "__VITE_ASSET__HAqbyy89__"